<template>
	<div class="terminos">
		<div id="demo-content">
			<div id="content" style="display: none"> 
			<picture>
      			<source rel="preconnect" v-bind:alt="url_images"  v-bind:srcset="url_images + portadas[1]" type="image/webp" class="portadas">
      			<source rel="preconnect" v-bind:alt="url_images" v-bind:srcset="url_images + portadas[2]" type="image/jp2"  class="portadas">
      			<img v-bind:alt="url_images" rel="preconnect" v-bind:src="url_images + portadas[0]"  class="portadas">     
    		</picture><br><br>
    		<div id="info" style="padding-top: 5px;padding-bottom: 5px;">
					<h3 id="titulo">TÉRMINOS Y CONDICIONES DE USO.</h3>
					<p class="text-justify">
						1. Estos Términos y Condiciones de Uso regulan las reglas a que se sujeta la utilización de la APP. La descarga o utilización de la APP atribuye la condición de Usuario a quien lo haga e implica la aceptación de todas las condiciones incluidas en este documento y en la Política de Privacidad y el Aviso Legal de dicha página Web. El Usuario debería leer estas condiciones cada vez que utilice la APP, ya que podrían ser modificadas en lo sucesivo. 
					</p>
					<p class="text-justify">
						2. Únicamente los Usuarios expresamente autorizados por <strong>{{ this.nameCompanie }}</strong> ¿podrán acceder a la descarga y uso de la APP. Los Usuarios que no dispongan de autorización, no podrán acceder a dicho contenido.	
					</p>
					<p class="text-justify">
						 3. Cargos: eres responsable del pago de todos los costes o gastos en los que incurras como resultado de descargar y usar la Aplicación de <strong>{{ this.nameCompanie }}</strong>, incluido cualquier cargo de red de operador o itinerancia. Consulta con tu proveedor de servicios los detalles al respecto. 
					</p>
					<p class="text-justify">
						 4. Estadísticas anónimas: <strong>{{ this.nameCompanie }}</strong> se reserva el derecho a realizar un seguimiento de tu actividad en la Aplicación de y a informar de ello a nuestros proveedores de servicios estadísticos de terceros. Todo ello de forma anónima. 
					</p>
					<p class="text-justify">
						5. Protección de tu información personal: queremos ayudarte a llevar a cabo todos los pasos necesarios para proteger tu privacidad e información. Consulta la Política de privacidad de <strong>{{ this.nameCompanie }}</strong> y los avisos sobre privacidad de la Aplicación para conocer qué tipo de información recopilamos y las medidas que tomamos para proteger tu información personal. 
					</p>
					<p class="text-justify">
						6. Queda prohibido alterar o modificar ninguna parte de la APP a de los contenidas de la misma, eludir, desactivar o manipular de cualquier otra forma (o tratar de eludir, desactivar o manipular) las funciones de seguridad u otras funciones del programa y utilizar la APP o sus contenidos para un fin comercial o publicitario. Queda prohibido el uso de la APP con la finalidad de lesionar bienes, derechos o intereses de <strong>{{ this.nameCompanie }}</strong> o de terceros. Queda igualmente prohibido realizar cualquier otro uso que altere, dañe o inutilice las redes, servidores, equipos, productos y programas informáticos de <strong>{{ this.nameCompanie }}</strong> o de terceros. 
					</p>
					<p class="text-justify">
						7. La APP y sus contenidos (textos, fotografías, gráficos, imágenes, tecnología, software, links, contenidos, diseño gráfico, código fuente, etc.), así como las marcas y demás signos distintivos son propiedad de <strong>{{ this.nameCompanie }}</strong> o de terceros, no adquiriendo el Usuario ningún derecho sobre ellos por el mero uso de la APP. El Usuario, deberá abstenerse de: a) Reproducir, copiar, distribuir, poner a disposición de terceros, comunicar públicamente, transformar o modificar la APP o sus contenidos, salvo en los casos contemplados en la ley o expresamente autorizados por <strong>{{ this.nameCompanie }}</strong> o por el titular de dichos derechos. b) Reproducir o copiar para uso privado la APP o sus contenidos, así como comunicarlos públicamente o ponerlos a disposición de terceros cuando ello conlleve su reproducción. c) Extraer o reutilizar todo o parte sustancial de los contenidos integrantes de la APP. 
					</p>
					<p class="text-justify">
						8. Con sujeción a las condiciones establecidas en el apartado anterior, <strong>{{ this.nameCompanie }}</strong> concede al Usuario una licencia de uso de la APP, no exclusiva, gratuita, para uso personal, circunscrita al territorio nacional y con carácter indefinido. Dicha licencia se concede también en los mismos términos con respecto a las actualizaciones y mejoras que se realizasen en la aplicación. Dichas licencias de uso podrán ser revocadas por <strong>{{ this.nameCompanie }}</strong> unilateralmente en cualquier momento, mediante la mera notificación al Usuario. 
					</p>
					<p class="text-justify">
						9. Corresponde al Usuario, en todo caso, disponer de herramientas adecuadas para la detección y desinfección de programas maliciosos o cualquier otro elemento informático dañino. <strong>{{ this.nameCompanie }}</strong> no se responsabiliza de los daños producidos a equipos informáticos durante el uso de la APP. Igualmente, <strong>{{ this.nameCompanie }}</strong> no será responsable de los daños producidos a los Usuarios cuando dichos daños tengan su origen en fallos o desconexiones en las redes de telecomunicaciones que interrumpan el servicio. 
					</p>
					<p class="text-justify">
						10. IMPORTANTE: Podemos, sin que esto suponga ninguna obligación contigo, modificar estas Condiciones de uso sin avisar en cualquier momento. Si continúas utilizando la aplicación una vez realizada cualquier modificación en estas Condiciones de uso, esa utilización continuada constituirá la aceptación por tu parte de tales modificaciones. Si no aceptas estas condiciones de uso ni aceptas quedar sujeto a ellas, no debes utilizar la aplicación ni descargar o utilizar cualquier software relacionado. El uso que hagas de la aplicación queda bajo tu única responsabilidad. No tenemos responsabilidad alguna por la eliminación o la incapacidad de almacenar o trasmitir cualquier contenido u otra información mantenida o trasmitida por la aplicación. No somos responsables de la precisión o la fiabilidad de cualquier información o consejo trasmitidos a través de la aplicación. Podemos, en cualquier momento, limitar o interrumpir tu uso a nuestra única discreción. Hasta el máximo que permite la ley, en ningún caso seremos responsables por cualquier pérdida o daño relacionados. 
					</p>
					<p class="text-justify">
						11. El Usuario se compromete a hacer un uso correcto de la APP, de conformidad con la Ley, con los presentes Términos y Condiciones de Uso y con las demás reglamentos e instrucciones que, en su caso, pudieran ser de aplicación El Usuario responderá frente a <strong>{{ this.nameCompanie }}</strong> y frente a terceros de cualesquiera daños o perjuicios que pudieran causarse por incumplimiento de estas obligaciones.
					</p>
				</div>
			</div>
		</div>
	</div>
</template>
<style scoped>	
	h3{
		font-size: 21px !important;
		font-weight: 500;
		margin-bottom: 20px;
		text-align: center !important;
	}
	p{
		margin-left: 10px;
		margin-right: 10px;
	}
	.portadas{
    	width: 100%;
    	height: auto;
  	}  	
  	@supports(object-fit: cover){
	    .portadas{
	      height: 100%;
	      object-fit: cover;
	      object-position: center center;
	    }
  	}
</style>
<script>
import Vue from 'vue'
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css' //Vuesax styles
import axios from 'axios';
  Vue.use(Vuesax, {
    // 
   })
export default {
	data() {
		return {
			idCompanie: this.$route.params.id_companie,
			nameCompanie: '',
			url_images:null,
  			portadas: [],
  			url: 'https://back.vinapp.co/api/company/get-data-company/'
		}	
	},
	methods:{
		setupCompanie(){          
  		axios.get(this.url+this.idCompanie)
  		.then(res => {
  			if(res.data.statusCode == 200){  				
  				this.portadas = res.data.store.portadas;  				
  				this.url_images = res.data.url_images; 
  				document.getElementById("titulo").style = `color:${res.data.store.color_letra}`;
  				document.getElementById('content').style.display = 'block';  				
  			}
  			})
		    .catch(err => {
		        console.log(err);      
		    });
  		},
	},
	mounted() {    
		this.nameCompanie = this.$route.params.name;	
		this.setupCompanie();	
	}
}
</script>